import type { FaireThemeEntity } from "../../entity_types/theme";

export const luxe_sparkle_for_less: FaireThemeEntity = {
  token: "luxe-sparkle-for-less",
  type: "theme",
  name: "Luxe Sparkle for Less",
  description: "High-impact pieces with zircon inlays and pave settings -- instant glamour without breaking the bank.",
  teaser: "Affordable sparkle your beauty-conscious clients seek.",
  detail: "Fashion-forward styles with sparkling accessories. Built around the pave dome rings and zircon-inlaid fringe earrings in your recent cart -- clear interest in affordable luxury.",
  bgColor: "#EDE0F5",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ut3tbs6mrw",
    "p_3pcekmbkc4",
    "p_m8ybpjvqmq",
    "p_tpf2apke3k",
    "p_zxurf3jtrh",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
